import { PayloadAction } from "@reduxjs/toolkit";

import { CarsState } from '../../types';

export const updateCarsLocationHistorySharingFilter = (
  state: CarsState,
  action: PayloadAction<Partial<CarsState['locationHistorySharing']['filter']>>
) => {
  state.locationHistorySharing.filter = {
    ...state.locationHistorySharing.filter,
    ...action.payload
  }
}
